import { Edit, ListButton, TopToolbar } from 'react-admin';
import ChevronLeft from '@material-ui/icons/ChevronLeft';

import RelatedTypeForm from './RelatedTypeForm';

const RelatedTypeActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const RelatedTypeEdit = (props: any) => {
  return (
    <Edit actions={<RelatedTypeActions {...props} />} {...props}>
      <RelatedTypeForm />
    </Edit>
  );
};

export default RelatedTypeEdit;
